export const AGREEMENT_SECTIONS = [
  {
    title: "Section 1 — Renter Identification Details",
    body: [
      "The renter provides: full name, date of birth, home address, postcode, contact number and email address.",
    ],
  },
  {
    title: "Section 2 — Driving Licence Details",
    body: [
      "Driving licence number, issuing authority (DVLA/EU/Other), licence type (Full UK / EU/EEA / International), issue date and expiry date are recorded.",
      "National Insurance Number is optional.",
    ],
  },
  {
    title: "Section 3 — Additional Identification",
    body: [
      "ID Type 1: Passport or photo ID. ID Type 2: Utility bill or bank statement, with issue date recorded.",
    ],
  },
  {
    title: "Section 4 — Vehicle Details & Hire Period",
    body: [
      "Vehicle make/model, registration, fuel type, mileage at collection and fuel level at collection are recorded, along with accessories provided (keys, logbook copy, insurance certificate, tools/jack, spare wheel/foam, dashcam or other).",
      "Hire start and end dates and times, total duration, and handover and return locations are confirmed.",
    ],
  },
  {
    title: "Section 5 — Important Notice (Applies Throughout Rental Period)",
    body: [
      "The Renter must keep the Vehicle secure at all times; use the Vehicle responsibly and lawfully; maintain oil, coolant, AdBlue and tyre pressure; report warning lights, faults or damage immediately; ensure only authorised drivers operate the Vehicle; not smoke, vape or use nitrous oxide (\u201cballooning\u201d); not use the Vehicle for illegal or dangerous purposes; and return the Vehicle on time, in the same condition, with all keys and documents.",
      "Failure to comply may result in breach warnings, breach fees, immediate repossession, liability for damages, termination of rental and civil recovery action.",
    ],
  },
  {
    title: "Section 6 — Terms & Conditions",
    terms: [
      ["6.1 Definitions", "Owner: Senna Prestige Travels. Renter: the individual/company hiring the Vehicle. Vehicle: the vehicle identified in this Agreement. Rental Period: from collection to return."],
      ["6.2 Condition of Vehicle", "Vehicle supplied in good working order. Renter must inspect before taking possession. Once driven away, the Vehicle is accepted \u201cas seen\u201d."],
      ["6.3 Authorised Drivers Only", "Only listed drivers may operate the Vehicle. Unauthorised drivers are a serious breach. The Owner may repossess immediately."],
      ["6.4 Use of Vehicle", "Prohibited uses include courier work (unless agreed), towing, racing, off-road use, hazardous goods, illegal activity, smoking/vaping and transporting animals without permission."],
      ["6.5 Prohibited Substances — Nitrous Oxide (\u201cBallooning\u201d)", "Strictly prohibited: inhaling, storing or transporting nitrous oxide, or allowing passengers to use it. Evidence equals a serious breach. Consequences: cleaning fees, damage charges, breach fee, repossession and possible police report."],
      ["6.6 Vehicle Damage & Costs", "Renter is liable for all damage including bodywork, tyres, wheels, windscreen, mirrors, interior, electronics and mechanical components. All repair costs are invoiced in full."],
      ["6.7 Accidents & Liability", "Renter must stop, exchange details, notify police if required, not admit liability, contact the Owner immediately and provide a written report within 24 hours."],
      ["6.8 Driving Under the Influence", "Zero tolerance for alcohol, drugs, nitrous oxide or impairing medication. Evidence equals immediate repossession."],
      ["6.9 Vehicle Seizure", "If seized due to the Renter's actions: the Renter pays all release/storage fees. No refund. If unrecoverable, the full market value is owed."],
      ["6.10 Breach Warnings & Repossession", "Maximum 3 warnings (verbal, text, email or written). After the 3rd warning, immediate repossession. Serious breaches lead to repossession without warnings. No refund. Renter pays repossession costs."],
      ["6.11 Fines & Penalties", "Renter is responsible for all fines, tolls, congestion charges and private parking charges. An admin fee applies."],
      ["6.12 Mileage", "Excess mileage is charged at the stated rate."],
      ["6.13 Breakdown", "Renter must contact the Owner immediately."],
      ["6.14 Return of Vehicle", "Must be returned on time, to the agreed location, in the same condition, with all keys and documents."],
      ["6.15 Payments & Deposits", "All charges are due before or at collection. A deposit may be required. The Owner may deduct sums owed."],
      ["6.16 Termination", "The Owner may terminate immediately for breach or misuse."],
      ["6.17 Governing Law", "England & Wales jurisdiction."],
    ],
  },
  {
    title: "Section 7 — Vehicle Condition Checklist (Before & After)",
    body: [
      "Photographic evidence is taken before delivery and at return, covering all sides, wheels, interior, dashboard, mileage, fuel level and any damage.",
      "Exterior, interior, mechanical and accessory checks are completed and signed at both handover and return.",
    ],
  },
  {
    title: "Section 8 — Damage Summary",
    body: [
      "Any new damage found is recorded with a description and estimated cost. Damage charges are assessed per the Vehicle Repair Cost Schedule and approved by the Owner.",
    ],
  },
  {
    title: "Section 10 — Handover & Return Receipt",
    body: [
      "The condition report is signed by the inspector before delivery and after return, with renter acknowledgement confirming the report is accurate.",
    ],
  },
];

export const REPAIR_SCHEDULE = [
  {
    group: "1. Exterior Damage",
    subgroups: [
      ["Bodywork", [
        ["Minor scratch (under 10cm)", "£90 – £150"],
        ["Medium scratch (10–30cm)", "£190 – £300"],
        ["Deep scratch requiring paint", "£360 – £700"],
        ["Dent (no paint damage)", "£160 – £300"],
        ["Dent with paint damage", "£400 – £900"],
        ["Panel respray (per panel)", "£500 – £900"],
        ["Panel replacement", "£700 – £1,500"],
      ]],
      ["Bumpers", [
        ["Minor scuff", "£90 – £180"],
        ["Deep scuff requiring paint", "£300 – £500"],
        ["Bumper crack repair", "£500 – £800"],
        ["Bumper replacement", "£900 – £1,800"],
      ]],
      ["Glass", [
        ["Windscreen chip repair", "£80 – £150"],
        ["Windscreen replacement", "£500 – £900"],
        ["Side window replacement", "£300 – £600"],
        ["Rear window replacement", "£400 – £700"],
      ]],
      ["Lights & Mirrors", [
        ["Mirror glass", "£80 – £120"],
        ["Mirror housing", "£240 – £500"],
        ["Headlight/taillight unit", "£300 – £700"],
        ["Indicator unit", "£120 – £240"],
      ]],
      ["Tyres & Wheels", [
        ["Puncture repair", "£50 – £80"],
        ["Tyre replacement (standard)", "£160 – £300"],
        ["Tyre replacement (premium)", "£300 – £500"],
        ["Alloy scuff repair", "£120 – £240"],
        ["Alloy replacement", "£400 – £900"],
      ]],
    ],
  },
  {
    group: "2. Interior Damage",
    subgroups: [
      ["Seats & Upholstery", [
        ["Minor stain cleaning", "£80 – £160"],
        ["Deep cleaning/valet", "£240 – £360"],
        ["Burn marks (smoking/vaping)", "£300 – £600"],
        ["Seat fabric repair", "£240 – £500"],
        ["Seat replacement", "£700 – £1,500"],
      ]],
      ["Dashboard & Controls", [
        ["Dashboard scratch", "£80 – £180"],
        ["Dashboard crack", "£300 – £600"],
        ["Broken switches/buttons", "£80 – £240"],
        ["Infotainment screen damage", "£600 – £1,800"],
      ]],
      ["Odour Removal", [
        ["Smoking/vaping odour", "£300 – £500"],
        ["Nitrous oxide odour", "£360 – £600"],
        ["Food spill odour", "£160 – £300"],
      ]],
    ],
  },
  {
    group: "3. Mechanical Damage",
    subgroups: [
      ["Engine & Transmission", [
        ["Misfuelling (drain & flush)", "£360 – £700"],
        ["Misfuelling with damage", "£1,000 – £5,000"],
        ["Engine damage due to negligence", "£2,000 – £8,000"],
        ["Transmission damage", "£2,400 – £7,000"],
      ]],
      ["Brakes & Suspension", [
        ["Brake pads", "£240 – £400"],
        ["Brake discs", "£400 – £700"],
        ["Suspension damage", "£500 – £1,500"],
        ["Shock absorber", "£300 – £600"],
      ]],
      ["Exhaust & Undercarriage", [
        ["Exhaust damage", "£300 – £700"],
        ["Catalytic converter damage", "£800 – £2,400"],
        ["Undercarriage impact damage", "£400 – £1,200"],
      ]],
    ],
  },
  {
    group: "4. Electrical & Electronic Damage",
    subgroups: [
      ["Electrical", [
        ["Battery damage", "£240 – £400"],
        ["Wiring damage", "£300 – £900"],
        ["Sensor damage (ABS/parking/etc.)", "£160 – £400"],
        ["ECU damage", "£600 – £1,800"],
      ]],
    ],
  },
  {
    group: "5. Lost or Damaged Accessories",
    subgroups: [
      ["Accessories", [
        ["Key replacement", "£300 – £700"],
        ["Key reprogramming", "£160 – £300"],
        ["Logbook replacement admin fee", "£90"],
        ["Dashcam replacement", "£160 – £300"],
        ["Child seat replacement", "£80 – £160"],
        ["Tools/jack replacement", "£80 – £160"],
        ["Spare wheel replacement", "£160 – £300"],
      ]],
    ],
  },
  {
    group: "6. Cleaning & Contamination Fees",
    subgroups: [
      ["Cleaning", [
        ["Standard cleaning (excess dirt)", "£80 – £120"],
        ["Deep interior cleaning", "£240 – £360"],
        ["Vomit/urine/faeces cleaning", "£300 – £600"],
        ["Nitrous oxide residue cleaning", "£300 – £500"],
        ["Pet hair removal (unauthorised animals)", "£160 – £300"],
      ]],
    ],
  },
  {
    group: "7. Administrative Fees",
    subgroups: [
      ["Admin", [
        ["Processing fines/penalties", "£50 per incident"],
        ["Late return fee", "Daily rental rate + £50"],
        ["Repossession fee", "£300 – £700 + mileage"],
        ["Vehicle seizure admin fee", "£300"],
        ["Insurance excess (if applicable)", "£500 – £2,000"],
      ]],
    ],
  },
  {
    group: "8. Total Loss / Write-Off",
    subgroups: [
      ["Total Loss", [
        ["Vehicle written off or stolen", "Full market value at time of loss, plus recovery, storage and administrative fees"],
      ]],
    ],
  },
];
